
import SettingsIcon from '@mui/icons-material/Settings';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import InventoryIcon from '@mui/icons-material/Inventory';


const FactoryConfiguration = {
  id: '7',
  title: 'Factory Configuration',
  type: 'group',
  role:'FACTORY_MANAGER,FACTORY_ADMIN',
  children: [
    {
      id: 'mfproduct',
      title: 'Product',
      type: 'item',
      url: '/',
      bottomMenu:'PRODUCTS',
      icon: QrCode2Icon
    },
    {
      id: 'inventory',
      title: 'Inventory Product',
      type: 'item',
      url: '/',
      bottomMenu:'INVENTORY-PRODUCT',
      icon: InventoryIcon
    },
    {
      id: 'category',
      title: 'Category',
      type: 'item',
      url: '/',
      bottomMenu:'CATEGORY',
      icon: InventoryIcon
    }
    ,{
      id: 'inventorymgmt',
      title: 'Inventory Mgmt',
      type: 'item',
      url: '/',
      bottomMenu:'INVENTORY-MGMT',
      icon: InventoryIcon
    },
  ]
};

export default FactoryConfiguration;